import React from 'react'
import { Notification } from '../notifications/use-notifications-manager'
import style from './index.scss'

export interface NotificationFlags {
  sessionExpired?: boolean
  passwordResetExpired?: boolean
  passwordResetSuccess?: boolean
  userIsBlocked?: boolean
  genericIssue?: boolean
}

interface Options {
  forgotPasswordUrl: string
  initialNotificationFlags?: NotificationFlags
}

const getInitialNotifications = ({
  initialNotificationFlags,
  forgotPasswordUrl,
}: Options): Notification[] => {
  const initialNotifications = []

  if (initialNotificationFlags?.sessionExpired) {
    initialNotifications.push({
      id: 'app/session-expired',
      type: 'info' as const,
      message: 'Session expired, please sign in again.',
    })
  }

  if (initialNotificationFlags?.passwordResetExpired) {
    initialNotifications.push({
      id: 'app/password-reset-expired',
      type: 'failure' as const,
      message: (
        <>
          Your password reset link has expired.{' '}
          <a href={forgotPasswordUrl} className={style.notificationLink}>
            Request a new link
          </a>
          .
        </>
      ),
    })
  }

  if (initialNotificationFlags?.passwordResetSuccess) {
    initialNotifications.push({
      id: 'app/password-reset-success',
      type: 'success' as const,
      message:
        'You have successfully reset your password. Sign in with your new password to access your account.',
    })
  }

  if (initialNotificationFlags?.userIsBlocked) {
    initialNotifications.push({
      id: 'app/user-is-blocked',
      type: 'failure' as const,
      message:
        'For security reasons this account has been blocked. Please contact Customer Support.',
    })
  }

  if (initialNotificationFlags?.genericIssue) {
    initialNotifications.push({
      id: 'app/generic-issue',
      type: 'failure' as const,
      message:
        'There was a problem loading this information. Please try again.',
    })
  }

  return initialNotifications
}

export default getInitialNotifications
